import AbstractNode from './AbstractNode';
import {InputRule} from 'prosemirror-inputrules';

const mathInlineInputRule = (pattern, nodeType, getAttrs) => {
    return new InputRule(pattern, (state, match, start, end) => {
        const m = match.length - 1;
        let matchStart = start;
        if (match[m]) {
            matchStart = start + match[0].indexOf(match[m - 1]);
        }
        let $start = state.doc.resolve(start);
        let index = $start.index();
        let $end = state.doc.resolve(end);
        let attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs
        if (!$start.parent.canReplaceWith(index, $end.index(), nodeType)) {
            return null;
        }
        return state.tr.replaceWith(
            matchStart, end,
            nodeType.create(attrs, nodeType.schema.text(match[match.length - 1]))
        );
    });
}

export default class MathInline extends AbstractNode {
    get name() {
        return "math_inline";
    }

    get schema() {
        return {
            content: "text*",
            group: "inline",
            inline: true,
            selectable: false,
            parseDOM: [{
                tag: 'span.math'
            }],
            toDOM: () => ["span", {
                class: 'math'
            }, 0]
        }
    }

    toMarkdown(state, node) {
        state.write('$');
        state.text(node.textContent, false);
        state.write('$');
    }

    get parseMarkdown() {
        return {
            block: "math_inline",
            noCloseToken: true
        }
    }

    inputRules({type}) {
        return [mathInlineInputRule(/(?:^|[^$\\])(\$([^$]+)\$)$/, type)];
    }
}